import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const DEACTIVATE_ALARM_THRESHOLDS = 'DEACTIVATE_ALARM_THRESHOLDS';
export const DEACTIVATE_ALARM_THRESHOLDS_SUCCESS =
  'DEACTIVATE_ALARM_THRESHOLDS_SUCCESS';
export const DEACTIVATE_ALARM_THRESHOLDS_FAILED =
  'DEACTIVATE_ALARM_THRESHOLDS_FAILED';
export const DEACTIVATE_ALARM_THRESHOLDS_RESET =
  'DEACTIVATE_ALARM_THRESHOLDS_RESET';
export const ACTIVATE_ALARM_THRESHOLDS = 'ACTIVATE_ALARM_THRESHOLDS';
export const ACTIVATE_ALARM_THRESHOLDS_SUCCESS =
  'ACTIVATE_ALARM_THRESHOLDS_SUCCESS';
export const ACTIVATE_ALARM_THRESHOLDS_FAILED =
  'ACTIVATE_ALARM_THRESHOLDS_FAILED';
export const ACTIVATE_ALARM_THRESHOLDS_RESET =
  'ACTIVATE_ALARM_THRESHOLDS_RESET';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSE_MODAL_RESET = 'CLOSE_MODAL_RESET';
export const UPDATE_THRESHOLDS = 'UPDATE_THRESHOLDS';
export const UPDATE_THRESHOLDS_SUCCESS = 'UPDATE_THRESHOLDS_SUCCESS';
export const UPDATE_THRESHOLDS_FAILED = 'UPDATE_THRESHOLDS_FAILED';
export const UPDATE_THRESHOLDS_RESET = 'UPDATE_THRESHOLDS_RESET';

export class DeactivateAlarmThresholds implements Action {
  type = DEACTIVATE_ALARM_THRESHOLDS;

  constructor(public payload: any) {}
}

export class DeactivateAlarmThresholdsSuccess implements Action {
  type = DEACTIVATE_ALARM_THRESHOLDS_SUCCESS;

  constructor(public payload: any) {}
}

export class DeactivateAlarmThresholdsFailed implements Action {
  type = DEACTIVATE_ALARM_THRESHOLDS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class DeactivateAlarmThresholdsReset implements Action {
  type = DEACTIVATE_ALARM_THRESHOLDS_RESET;

  constructor(public payload: any) {}
}

export class ActivateAlarmThresholds implements Action {
  type = ACTIVATE_ALARM_THRESHOLDS;

  constructor(public payload: any) {}
}

export class ActivateAlarmThresholdsSuccess implements Action {
  type = ACTIVATE_ALARM_THRESHOLDS_SUCCESS;

  constructor(public payload: any) {}
}

export class ActivateAlarmThresholdsFailed implements Action {
  type = ACTIVATE_ALARM_THRESHOLDS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class ActivateAlarmThresholdsReset implements Action {
  type = ACTIVATE_ALARM_THRESHOLDS_RESET;

  constructor(public payload: any) {}
}

export class CloseModal implements Action {
  type = CLOSE_MODAL;

  constructor(public payload?: any) {}
}

export class CloseModalReset implements Action {
  type = CLOSE_MODAL_RESET;

  constructor(public payload: any) {}
}

export class UpdateThresholds implements Action {
  type = UPDATE_THRESHOLDS;

  constructor(public payload: any) {}
}

export class UpdateThresholdsSuccess implements Action {
  type = UPDATE_THRESHOLDS_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateThresholdsFailed implements Action {
  type = UPDATE_THRESHOLDS_FAILED;

  constructor(public payload: any) {}
}

export class UpdateThresholdsReset implements Action {
  type = UPDATE_THRESHOLDS_RESET;

  constructor(public payload: any) {}
}

export type Actions =
  | DeactivateAlarmThresholds
  | DeactivateAlarmThresholdsSuccess
  | DeactivateAlarmThresholdsFailed
  | DeactivateAlarmThresholdsReset
  | ActivateAlarmThresholds
  | ActivateAlarmThresholdsSuccess
  | ActivateAlarmThresholdsFailed
  | ActivateAlarmThresholdsReset
  | CloseModal
  | CloseModalReset
  | UpdateThresholds
  | UpdateThresholdsSuccess
  | UpdateThresholdsFailed
  | UpdateThresholdsReset;
